var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFestivalIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 121,
    viewBox: "0 0 115 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.1292 35.3671L62.3952 30.9336C62.3952 30.9336 46.1217 52.4298 45.9508 69.0389C45.7799 85.6477 56.1265 105.829 56.1265 105.829L85.9049 109.524C85.9049 109.524 100.869 92.4825 104.763 76.3355C108.656 60.1885 98.1292 35.3671 98.1292 35.3671Z",
    fill: "url(#paint0_linear_1855_11466)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.522 52.2934C103.41 51.8155 103.295 51.3423 103.179 50.875C97.1168 51.3725 88.9968 51.4352 78.8196 50.1725C67.3177 48.7455 59.2302 46.7274 53.6583 44.832C53.4316 45.2565 53.2058 45.6875 52.9806 46.1234C58.6663 48.0634 66.9059 50.113 78.6462 51.5697C89.1011 52.8665 97.3645 52.8051 103.522 52.2934Z",
    fill: "#F3D13A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.732 49.1495C102.603 48.6667 102.473 48.1916 102.342 47.7249C96.4255 48.1302 88.7161 48.1052 79.2222 46.9274C68.506 45.5979 60.7559 43.755 55.2393 41.9766C54.9996 42.3952 54.759 42.8221 54.5178 43.2565C60.1492 45.0815 68.0701 46.9623 79.0488 48.3243C88.8238 49.5372 96.7142 49.5687 102.732 49.1495Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.208 55.4482C104.112 54.9691 104.014 54.4937 103.912 54.0217C97.7461 54.6078 89.2467 54.7642 78.4164 53.4208C66.156 51.8997 57.7686 49.7069 52.181 47.707C51.9681 48.1377 51.758 48.5729 51.5498 49.0122C57.254 51.0556 65.7747 53.2709 78.2433 54.8176C89.321 56.1919 97.9543 56.0448 104.208 55.4482Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2419 98.4319C94.5661 97.9445 94.8922 97.4466 95.2195 96.9376C89.4418 97.2723 82.0888 97.1939 73.1233 96.0815C63.0852 94.8362 55.6473 93.1401 50.2109 91.4688C50.4024 92.0364 50.5952 92.5932 50.789 93.1392C56.2128 94.726 63.4285 96.2975 72.9499 97.4787C81.4931 98.5386 88.5695 98.6889 94.2419 98.4319Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9938 83.9844C48.1357 84.5461 48.2823 85.1036 48.4331 85.657C54.1058 87.5628 62.2486 89.5596 73.7557 90.9873C84.0533 92.265 92.2278 92.2249 98.3565 91.7348C98.6391 91.2325 98.9179 90.7251 99.1934 90.2121C93.0462 90.7803 84.6264 90.9176 73.9291 89.5905C61.8892 88.0965 53.5802 85.9547 47.9938 83.9844Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5262 92.8348C62.4707 91.4629 54.5639 89.5448 49.0186 87.7148C49.1861 88.2791 49.3561 88.8377 49.5298 89.3881C55.1121 91.1418 62.823 92.9251 73.3528 94.2316C82.7903 95.4026 90.446 95.4655 96.3809 95.0919C96.6839 94.5996 96.9853 94.0983 97.2854 93.5912C91.2922 94.0419 83.3589 94.0545 73.5262 92.8348Z",
    fill: "#F3D13A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5659 102.531C55.5024 104.608 56.1268 105.827 56.1268 105.827L85.9052 109.522C85.9052 109.522 86.8084 108.492 88.2244 106.707L54.5659 102.531Z",
    fill: "#EDEDED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.754 54.1248L93.9177 98.9255L91.6747 48.9956L76.7037 96.7895L74.1081 46.8162L59.3406 93.9601L56.5414 44.6367L47.4839 81.6697",
    stroke: "white",
    strokeWidth: 1.0942,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7214 91.0926L100.458 50.0894L85.6077 97.8984L82.8912 47.9099L68.1237 95.0538L65.3248 45.7305L50.855 93.3387L49.1799 54.5047",
    stroke: "white",
    strokeWidth: 1.0942,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5414 44.6435C56.5414 44.6435 58.5592 38.3424 63.4354 34.0391",
    stroke: "#C16921",
    strokeWidth: 1.7394,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8541 39.7104C58.8541 39.7104 59.965 37.2786 63.9269 33.6641",
    stroke: "#EDEDED",
    strokeWidth: 4.3768,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3249 45.7243C65.3249 45.7243 65.911 40.2539 68.8546 35.7266",
    stroke: "#C16921",
    strokeWidth: 1.7394,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3244 41.661C66.3244 41.661 67.5442 37.0642 69.2556 35.168",
    stroke: "#EDEDED",
    strokeWidth: 4.3768,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.108 46.8147L75.2337 37.7422",
    stroke: "#C16921",
    strokeWidth: 1.7394,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6201 42.6893L75.3833 36.5391",
    stroke: "#EDEDED",
    strokeWidth: 4.3768,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8912 47.9034C82.8912 47.9034 82.7055 42.7042 81.7998 38.25",
    stroke: "#C16921",
    strokeWidth: 1.7394,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5766 43.6736C82.5766 43.6736 82.6577 40.5613 81.8735 37.6562",
    stroke: "#EDEDED",
    strokeWidth: 4.3768,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6749 48.9967C91.6749 48.9967 91.3143 43.9595 88.856 39.1289",
    stroke: "#C16921",
    strokeWidth: 1.7394,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9904 45.0147C90.9904 45.0147 90.1198 40.5886 88.4127 38.4727",
    stroke: "#EDEDED",
    strokeWidth: 4.3768,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.458 50.091C100.458 50.091 99.1367 43.7115 96.4507 38.5469",
    stroke: "#C16921",
    strokeWidth: 1.7394,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1769 45.3241C99.1769 45.3241 97.7878 40.9187 96.0128 38.0781",
    stroke: "#EDEDED",
    strokeWidth: 4.3768,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3407 93.9648C59.3407 93.9648 58.5723 99.4124 60.3201 104.522",
    stroke: "#C16921",
    strokeWidth: 1.7394,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M59.316 98.1523C59.316 98.1523 59.3752 102.908 60.5715 105.165",
    stroke: "#EDEDED",
    strokeWidth: 4.3768,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.124 95.0508L66.9983 104.123",
    stroke: "#C16921",
    strokeWidth: 1.7394,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6118 99.1758L66.8489 105.326",
    stroke: "#EDEDED",
    strokeWidth: 4.3768,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9071 96.1367C76.9071 96.1367 75.4566 101.133 73.4894 105.231",
    stroke: "#C16921",
    strokeWidth: 1.7394,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5683 100.16C75.5683 100.16 74.8865 103.198 73.416 105.823",
    stroke: "#EDEDED",
    strokeWidth: 4.3768,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6906 97.2266C85.6906 97.2266 84.11 102.023 80.5457 106.106",
    stroke: "#C16921",
    strokeWidth: 1.7394,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0535 100.918C84.0535 100.918 82.1279 104.997 79.9553 106.632",
    stroke: "#EDEDED",
    strokeWidth: 4.3768,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.9508 69.0389C45.8931 74.6536 47.0388 80.675 48.5791 86.1885C54.1136 88.3291 65.932 89.2351 74.5829 85.1921C90.7413 77.6404 91.5983 45.8917 81.2014 33.267L62.3952 30.9336C62.3952 30.9336 46.1217 52.4298 45.9508 69.0389Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M98.1292 35.3612L92.0697 34.6094C94.9151 42.8333 99.3613 58.6416 96.651 70.1145C88.4647 104.767 53.5895 100.3 53.5895 100.3C55.0453 103.71 56.1268 105.824 56.1268 105.824L85.9052 109.518C85.9052 109.518 100.87 92.4769 104.763 76.3298C108.656 60.1825 98.1292 35.3612 98.1292 35.3612Z",
    fill: "#1F8297"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2863 37.7187C99.0321 39.7664 90.1881 40.3547 79.5325 39.0325C68.8768 37.7104 60.4446 34.9787 60.6985 32.931L60.9734 30.7148L99.5608 35.5025L99.2863 37.7187Z",
    fill: "#F64C4C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5611 35.503C99.3069 37.5508 90.463 38.1391 79.8073 36.8169C69.1516 35.4947 60.7195 32.7631 60.9734 30.7154C61.2276 28.6676 70.0715 28.0794 80.7272 29.4015C91.3832 30.7237 99.8153 33.4553 99.5611 35.503Z",
    fill: "#BAD8DF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2074 35.2085C97.0532 36.4514 89.3438 36.5183 79.9881 35.3575C70.6324 34.1966 63.1729 32.2482 63.3271 31.0051C63.4814 29.7622 71.1907 29.6952 80.5464 30.8561C89.9025 32.0169 97.3617 33.9656 97.2074 35.2085Z",
    fill: "#E9F3F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M67.149 49.4683C66.8708 51.7113 65.6356 53.4046 64.3906 53.25C63.1455 53.0955 62.3617 51.152 62.6399 48.9087C62.9182 46.6657 64.1533 44.9724 65.3984 45.127C66.6434 45.2815 67.4273 47.2253 67.149 49.4683Z",
    fill: "#F64C4C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9325 50.562C75.6542 52.805 74.419 54.4983 73.174 54.3438C71.929 54.1892 71.1451 52.2458 71.4234 50.0024C71.7016 47.7595 72.9368 46.0662 74.1818 46.2207C75.4269 46.3753 76.2107 48.3187 75.9325 50.562Z",
    fill: "#FFAD0D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4988 52.7339C93.2206 54.9769 91.9854 56.6702 90.7404 56.5156C89.4953 56.3611 88.7114 54.4176 88.9897 52.1743C89.268 49.9313 90.5031 48.2381 91.7482 48.3926C92.9935 48.5472 93.7774 50.4906 93.4988 52.7339Z",
    fill: "#F64C4C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3658 48.3824C58.0876 50.6253 56.8524 52.3186 55.6074 52.1641C54.3623 52.0095 53.5784 50.0658 53.8567 47.8228C54.135 45.5795 55.3701 43.8865 56.6152 44.041C57.8602 44.1956 58.6441 46.1391 58.3658 48.3824Z",
    fill: "#FFAD0D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7157 51.6519C84.4374 53.8949 83.2023 55.5882 81.9572 55.4336C80.7122 55.2791 79.9283 53.3356 80.2066 51.0923C80.4848 48.849 81.72 47.156 82.965 47.3106C84.2101 47.4651 84.9939 49.4089 84.7157 51.6519Z",
    fill: "#FFAD0D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M102.282 53.8238C102.004 56.0668 100.769 57.76 99.5239 57.6055C98.2789 57.4509 97.495 55.5075 97.7733 53.2642C98.0515 51.0212 99.2867 49.3279 100.532 49.4824C101.777 49.637 102.561 51.5808 102.282 53.8238Z",
    fill: "#FFAD0D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8748 91.98C61.5965 94.2233 60.3614 95.9163 59.1163 95.7617C57.8713 95.6072 57.0874 93.6634 57.3657 91.4204C57.6439 89.1774 58.8791 87.4841 60.1241 87.6387C61.3692 87.7932 62.1531 89.7367 61.8748 91.98Z",
    fill: "#F64C4C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6579 93.0699C70.3797 95.3128 69.1445 97.0061 67.8995 96.8516C66.6544 96.697 65.8706 94.7536 66.1488 92.5103C66.4271 90.2673 67.6622 88.574 68.9073 88.7285C70.1526 88.8831 70.9362 90.8269 70.6579 93.0699Z",
    fill: "#FFAD0D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2248 95.2456C87.9465 97.4886 86.7117 99.1819 85.4663 99.0274C84.2213 98.8728 83.4374 96.9294 83.7157 94.6861C83.9939 92.4431 85.2291 90.7498 86.4741 90.9043C87.7192 91.0589 88.503 93.0026 88.2248 95.2456Z",
    fill: "#F64C4C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0913 90.8902C52.813 93.1331 51.5779 94.8264 50.3328 94.6719C49.0878 94.5173 48.3039 92.5736 48.5822 90.3306C48.8604 88.0876 50.0956 86.3943 51.3406 86.5489C52.586 86.7034 53.3699 88.6472 53.0913 90.8902Z",
    fill: "url(#paint1_linear_1855_11466)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4416 94.1636C79.1633 96.4066 77.9281 98.0999 76.6831 97.9453C75.4381 97.7908 74.6542 95.847 74.9324 93.604C75.2107 91.361 76.4456 89.6677 77.6909 89.8223C78.936 89.9768 79.7198 91.9203 79.4416 94.1636Z",
    fill: "#FFAD0D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0079 96.3355C96.7296 98.5785 95.4947 100.272 94.2494 100.117C93.0043 99.9626 92.2205 98.0189 92.4987 95.7759C92.777 93.5329 94.0122 91.8396 95.2572 91.9942C96.5026 92.1487 97.2864 94.0925 97.0079 96.3355Z",
    fill: "#FFAD0D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9686 47.4345L43.9742 39.9336C43.9742 39.9336 60.0875 56.5671 61.9627 70.7106C63.8379 84.8538 57.1176 103.138 57.1176 103.138L32.1128 109.389C32.1128 109.389 17.5793 96.4176 12.5784 83.0557C7.57759 69.6939 13.9686 47.4345 13.9686 47.4345Z",
    fill: "url(#paint2_linear_1855_11466)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1326 62.4246C11.1788 62.0055 11.2269 61.5903 11.2778 61.1796C16.4982 60.9725 23.4278 60.1803 31.9739 58.0442C41.6318 55.6298 48.3177 53.0673 52.8707 50.8711C53.1085 51.2094 53.3457 51.5532 53.583 51.9014C48.9373 54.1476 42.1254 56.753 32.2672 59.2172C23.4879 61.412 16.436 62.22 11.1326 62.4246Z",
    fill: "#C16921"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4789 59.6587C11.5387 59.2337 11.6002 58.8151 11.6635 58.4034C16.7502 58.1327 23.3205 57.309 31.2927 55.3161C40.291 53.0667 46.707 50.6887 51.2252 48.5977C51.4733 48.9298 51.7228 49.2687 51.9739 49.6141C47.3625 51.7564 40.8046 54.1847 31.5859 56.4893C23.3776 58.5409 16.6535 59.3894 11.4789 59.6587Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8759 65.1818C10.9077 64.7635 10.9422 64.3477 10.9802 63.9346C16.2979 63.7925 23.5613 63.0408 32.6553 60.7674C42.9502 58.194 49.8731 55.4507 54.429 53.1641C54.6554 53.5092 54.8799 53.8584 55.1033 54.2112C50.4525 56.5473 43.4185 59.3232 32.9485 61.9406C23.6464 64.2659 16.2702 65.0391 10.8759 65.1818Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M23.849 100.795C23.5218 100.413 23.1918 100.023 22.8597 99.6226C27.8206 99.3066 34.082 98.4738 41.6103 96.5921C50.0393 94.4851 56.2044 92.2647 60.6655 90.2734C60.5612 90.7773 60.4549 91.2722 60.3465 91.7578C55.887 93.6755 49.8985 95.7667 41.9035 97.7653C34.7301 99.5585 28.7121 100.423 23.849 100.795Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7766 83.6602C61.7141 84.154 61.6472 84.6445 61.576 85.1318C56.9377 87.3473 50.2032 89.8978 40.5407 92.3133C31.8937 94.475 24.9198 95.292 19.6437 95.5124C19.3504 95.1134 19.0599 94.7098 18.7715 94.3011C24.0719 94.1453 31.2649 93.3857 40.2474 91.1404C50.3573 88.6132 57.2187 85.9218 61.7766 83.6602Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M40.929 93.8663C50.2125 91.5457 56.754 89.087 61.2915 86.9492C61.2072 87.4476 61.1205 87.9417 61.03 88.429C56.4529 90.5056 50.0643 92.829 41.2223 95.0393C33.2977 97.0202 26.7768 97.8711 21.6776 98.1704C21.3681 97.782 21.0591 97.386 20.7501 96.9849C25.9072 96.7455 32.6724 95.9302 40.929 93.8663Z",
    fill: "#C16921"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M58.105 100.164C57.5226 102.032 57.1173 103.137 57.1173 103.137L32.1125 109.387C32.1125 109.387 31.2353 108.604 29.8422 107.229L58.105 100.164Z",
    fill: "#EDEDED"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1251 64.0059L24.1763 101.179L20.8901 58.3748L38.6313 97.5658L35.6407 54.6874L53.1406 93.3454L50.3913 51L61.9698 81.6318",
    stroke: "white",
    strokeWidth: 1.0668,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2646 94.9979L13.5148 60.2185L31.1543 99.4351L28.2654 56.5311L45.7653 95.1892L43.016 52.8438L60.3102 91.9288L57.6946 58.6439",
    stroke: "white",
    strokeWidth: 1.0668,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3914 50.9954C50.3914 50.9954 48.0147 45.8328 43.4093 42.6719",
    stroke: "#C16921",
    strokeWidth: 1.6959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M47.906 47.0371C47.906 47.0371 46.7056 45.0792 42.9514 42.4102",
    stroke: "#EDEDED",
    strokeWidth: 4.2674,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0161 52.8363C43.0161 52.8363 41.947 48.2334 38.9656 44.6797",
    stroke: "#C16921",
    strokeWidth: 1.6959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7404 49.4769C41.7404 49.4769 40.2218 45.6846 38.5653 44.2461",
    stroke: "#EDEDED",
    strokeWidth: 4.2674,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6406 54.6847L33.736 47.0664",
    stroke: "#C16921",
    strokeWidth: 1.6959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7742 51.2231L33.4833 46.0586",
    stroke: "#EDEDED",
    strokeWidth: 4.2674,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2653 56.528C28.2653 56.528 27.8824 52.0759 28.1909 48.1836",
    stroke: "#C16921",
    strokeWidth: 1.6959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0933 52.8911C28.0933 52.8911 27.7 50.2457 28.0661 47.6875",
    stroke: "#EDEDED",
    strokeWidth: 4.2674,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8901 58.3828C20.8901 58.3828 20.6729 54.0505 22.2661 49.6758",
    stroke: "#C16921",
    strokeWidth: 1.6959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0588 54.9127C21.0588 54.9127 21.3401 51.0484 22.5753 49.0664",
    stroke: "#EDEDED",
    strokeWidth: 4.2674,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5147 60.2172C13.5147 60.2172 13.9767 54.6402 15.7294 49.957",
    stroke: "#C16921",
    strokeWidth: 1.6959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M14.111 56.0232C14.111 56.0232 14.8364 52.1222 16.0542 49.5156",
    stroke: "#EDEDED",
    strokeWidth: 4.2674,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1406 93.3516C53.1406 93.3516 54.363 97.9162 53.4048 102.455",
    stroke: "#C16921",
    strokeWidth: 1.6959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5975 96.918C53.5975 96.918 54.0421 100.979 53.2573 103.028",
    stroke: "#EDEDED",
    strokeWidth: 4.2674,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7652 95.1953L47.6698 102.814",
    stroke: "#C16921",
    strokeWidth: 1.6959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6316 98.6562L47.9225 103.821",
    stroke: "#EDEDED",
    strokeWidth: 4.2674,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3899 97.0352C38.3899 97.0352 40.1469 101.144 42.2507 104.433",
    stroke: "#C16921",
    strokeWidth: 1.6959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9506 100.324C39.9506 100.324 40.8483 102.843 42.3754 104.929",
    stroke: "#EDEDED",
    strokeWidth: 4.2674,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0146 98.8789C31.0146 98.8789 32.8616 102.804 36.3258 105.914",
    stroke: "#C16921",
    strokeWidth: 1.6959,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7953 101.859C32.7953 101.859 34.8618 105.137 36.8846 106.304",
    stroke: "#EDEDED",
    strokeWidth: 4.2674,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M61.9624 70.7103C62.5965 75.4915 62.2464 80.7446 61.5075 85.606C57.0116 88.0074 47.0292 90.0104 39.2323 87.4641C24.6689 82.7079 20.6326 55.7278 28.1824 43.8811L43.9739 39.9336C43.9739 39.9336 60.0872 56.5668 61.9624 70.7103Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M13.9686 47.432L19.0569 46.1602C17.4872 53.4683 15.3423 67.4096 18.8479 76.9094C29.4358 105.602 58.7058 98.1621 58.7058 98.1621C57.8199 101.221 57.1176 103.136 57.1176 103.136L32.1128 109.387C32.1128 109.387 17.5793 96.4152 12.5784 83.0533C7.57759 69.6914 13.9686 47.432 13.9686 47.432Z",
    fill: "#F7A47A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2263 49.5544C13.6562 51.2739 21.2579 50.8546 30.2054 48.6179C39.153 46.3812 46.0578 43.1741 45.6282 41.4546L45.1629 39.5938L12.7613 47.6939L13.2263 49.5544Z",
    fill: "#F64C4C"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7613 47.6937C13.1913 49.4132 20.793 48.9938 29.7405 46.7569C38.688 44.5202 45.5929 41.313 45.1632 39.5938C44.7333 37.8743 37.1316 38.2937 28.1841 40.5303C19.2366 42.767 12.3314 45.9742 12.7613 47.6937Z",
    fill: "#BAD8DF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7377 47.1969C14.9986 48.2407 21.5787 47.4947 29.4348 45.5309C37.2908 43.5671 43.4478 41.1288 43.1869 40.0852C42.926 39.0413 36.3459 39.7873 28.4898 41.7511C20.6337 43.7149 14.4768 46.153 14.7377 47.1969Z",
    fill: "#E9F3F5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8509 56.2292C42.3219 58.1128 43.5511 59.4276 44.5966 59.1665C45.6421 58.905 46.1079 57.1662 45.6372 55.2829C45.1662 53.3992 43.937 52.0844 42.8915 52.3456C41.846 52.607 41.3799 54.3458 41.8509 56.2292Z",
    fill: "url(#paint3_linear_1855_11466)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4756 58.0768C34.9466 59.9605 36.1758 61.2753 37.2213 61.0141C38.2668 60.7527 38.7326 59.0139 38.2619 57.1305C37.7912 55.2471 36.5617 53.932 35.5162 54.1932C34.4707 54.4547 34.0046 56.1934 34.4756 58.0768Z",
    fill: "#1F8297"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7249 61.7604C20.1956 63.644 21.4251 64.9589 22.4706 64.6977C23.5161 64.4363 23.9819 62.6975 23.5112 60.8141C23.0405 58.9307 21.811 57.6156 20.7655 57.8768C19.7198 58.1382 19.2539 59.877 19.7249 61.7604Z",
    fill: "url(#paint4_linear_1855_11466)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2261 54.3854C49.6969 56.2691 50.9264 57.5839 51.9719 57.3227C53.0174 57.0613 53.4832 55.3225 53.0125 53.4391C52.5415 51.5555 51.3123 50.2406 50.2668 50.5018C49.2213 50.7633 48.7552 52.502 49.2261 54.3854Z",
    fill: "url(#paint5_linear_1855_11466)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1002 59.9206C27.5709 61.8042 28.8004 63.119 29.8459 62.8579C30.8914 62.5964 31.3572 60.8576 30.8865 58.9743C30.4158 57.0906 29.1863 55.7758 28.1408 56.037C27.0953 56.2984 26.6292 58.0372 27.1002 59.9206Z",
    fill: "url(#paint6_linear_1855_11466)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3495 63.6042C12.8205 65.4878 14.0497 66.8026 15.0952 66.5415C16.1408 66.2803 16.6068 64.5412 16.1359 62.6579C15.6651 60.7742 14.4357 59.4594 13.3902 59.7206C12.3444 59.982 11.8786 61.7208 12.3495 63.6042Z",
    fill: "#1F8297"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7743 91.9206C51.245 93.8039 52.4745 95.119 53.52 94.8579C54.5655 94.5964 55.0313 92.8576 54.5606 90.9743C54.0899 89.0906 52.8604 87.7758 51.8149 88.037C50.7694 88.2981 50.3033 90.0369 50.7743 91.9206Z",
    fill: "url(#paint7_linear_1855_11466)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M43.399 93.7643C43.8697 95.6477 45.0992 96.9628 46.1447 96.7016C47.1902 96.4402 47.656 94.7014 47.1853 92.818C46.7146 90.9344 45.4851 89.6195 44.4396 89.8807C43.3941 90.1419 42.928 91.8807 43.399 93.7643Z",
    fill: "#1F8297"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6484 97.4479C29.1194 99.3315 30.3486 100.646 31.3941 100.385C32.4396 100.124 32.9054 98.385 32.4347 96.5016C31.964 94.6182 30.7345 93.3031 29.689 93.5643C28.6432 93.8255 28.1774 95.5643 28.6484 97.4479Z",
    fill: "url(#paint8_linear_1855_11466)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1496 90.069C58.6203 91.9526 59.8498 93.2675 60.8953 93.0063C61.9408 92.7449 62.4069 91.0061 61.9359 89.1227C61.4652 87.2391 60.2357 85.9242 59.1902 86.1854C58.1447 86.4466 57.6786 88.1854 58.1496 90.069Z",
    fill: "url(#paint9_linear_1855_11466)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0236 95.6042C36.4943 97.4878 37.7238 98.8026 38.7693 98.5415C39.8148 98.28 40.2806 96.5412 39.8099 94.6579C39.3389 92.7742 38.1097 91.4594 37.0642 91.7206C36.0187 91.9817 35.5526 93.7205 36.0236 95.6042Z",
    fill: "url(#paint10_linear_1855_11466)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M21.273 99.2878C21.744 101.171 22.9732 102.486 24.0187 102.225C25.0642 101.964 25.5303 100.225 25.0593 98.3414C24.5883 96.4578 23.3591 95.143 22.3136 95.4042C21.2678 95.6653 20.802 97.4041 21.273 99.2878Z",
    fill: "#1F8297"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1855_11466",
    x1: 120.585,
    y1: 30.9336,
    x2: 18.4768,
    y2: 74.5317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1855_11466",
    x1: 48.5845,
    y1: 90.3124,
    x2: 53.0893,
    y2: 90.9086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4194,
    stopColor: "#EAA627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#E58A21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1855_11466",
    x1: 62.2931,
    y1: 39.9336,
    x2: -4.83152,
    y2: 87.5338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1855_11466",
    x1: 45.8208,
    y1: 52.3125,
    x2: 39.7232,
    y2: 55.8208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1855_11466",
    x1: 23.6948,
    y1: 57.8438,
    x2: 17.5972,
    y2: 61.3521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1855_11466",
    x1: 49.2261,
    y1: 54.3855,
    x2: 53.0124,
    y2: 53.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4194,
    stopColor: "#EAA627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#E58A21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1855_11466",
    x1: 27.1001,
    y1: 59.9207,
    x2: 30.8864,
    y2: 58.9742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4194,
    stopColor: "#EAA627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#E58A21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1855_11466",
    x1: 54.7442,
    y1: 88.0039,
    x2: 48.6466,
    y2: 91.5122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1855_11466",
    x1: 32.6182,
    y1: 93.5313,
    x2: 26.5207,
    y2: 97.0396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1855_11466",
    x1: 58.1496,
    y1: 90.069,
    x2: 61.9359,
    y2: 89.1225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4194,
    stopColor: "#EAA627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#E58A21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1855_11466",
    x1: 36.0235,
    y1: 95.6041,
    x2: 39.8098,
    y2: 94.6576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4194,
    stopColor: "#EAA627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#E58A21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFestivalIllustration);
export default __webpack_public_path__ + "static/media/Festival Illustration.efe54303c956cb782936c6e955ff5956.svg";
export { ForwardRef as ReactComponent };